import uk from 'vuetify/lib/locale/uk'

export default {
  account: 'аккаунт',
  accountNotActive: 'обліковий запис вимкнено',
  accounts: 'аккаунти',
  active: 'активний',
  add: 'додати',
  addAccount: 'додати аккаунт',
  address: 'адрес',
  addSelected: 'додати вибране',
  additionalLanguage: 'додаткова мова',
  administration: 'адміністрування',
  all: 'всі',
  allBeverages: 'всі напої',
  any: 'будь-який',
  available: 'доступно',
  apiDocs: 'API документація',
  apiKeys: 'API ключі',
  apply: 'застосувати',
  allWeek: 'весь тиждень',
  assignedTo: 'тільки призначені',
  back: 'назад',
  backToLoginPage: 'повернутися на сторінку входу',
  beverage: 'напій',
  beverages: 'напої',
  beverageSales: 'продажі по напоям',
  brand: 'бренд',
  brands: 'бренди',
  businessHours: 'години роботи',
  byDays: 'по днях',
  cancel: 'скасувати',
  cancelDelete: 'скасувати видалення?',
  canceled: 'скасовані',
  cantDeleteFirstDeleteRelations:
    'видалення заборонено, спочатку видаліть пов’язані об’єкти',
  cantDeleteDefaultValue: 'неможливо видалити значення за замовчуванням',
  cause: 'причина',
  causeFaultGroup: 'група причин несправностей',
  causeFaultGroups: 'групи причин несправностей',
  causeFaults: 'причини несправностей',
  causeGroups: 'групи причин',
  causes: 'причини',
  changePassword: 'змінити пароль',
  cities: 'міста',
  city: 'місто',
  client: 'контрагент',
  clientFault: 'причина виклику',
  clientFaultGroup: 'група причини виклику',
  clientFaultGroups: 'групи причин виклику',
  clientFaults: 'причини виклику',
  clients: 'контрагенти',
  clone: 'клонувати',
  clientUsers: 'користувачі клієнта',
  close: 'закрити',
  closed: 'зачинено',
  code: 'код',
  color: 'колір',
  comment: 'коментар',
  taskComment: 'коментар до завдання',
  completedDate: 'дата завершення',
  connectionLost: 'з`єднання втрачено',
  connectionRestored: 'з`єднання відновлено',
  confirmDelete: 'ви впевнені, що хочете видалити цей елемент?',
  confirmOrderCancel:
    'ви впевнені, що хочете скасувати це наряд-замовлення? Ця дія незворотня',
  confirmPassword: 'підтвердьте пароль',
  connectServerError: 'помилка підключення до сервера',
  contactPerson: 'контактна особа',
  contactPersons: 'контактні особи',
  contract: 'договір',
  contractor: 'виконавець',
  contracts: 'договори',
  controlTechConditions: 'контроль техн. умов',
  counter: 'лічильник',
  counterFrom: 'лічильник від',
  counterTo: 'лічильник до',
  countries: 'країни',
  country: 'країна',
  create: 'створити',
  createdBasedOrder: 'створено на основі наряд-замовлення',
  createdDate: 'дата створення',
  createdOrder: 'створено наряд-замовлення',
  dashboard: 'панель управління',
  date: 'дата',
  dateEnd: 'дата закінчення',
  dateStart: 'дата початку',
  days: 'днів',
  daysDot: 'д.',
  decisionMakerName: 'ім`я ОПР',
  decisionMakerPhone: 'телефон ОПР',
  default: 'за замовчуванням',
  defaultLocationBusinessHours: 'години роботи локацій за умовчанням',
  defaultPageTitle: 'SERVICE DESK',
  defaultReactionTime: 'час реакції за замовчуванням',
  defaultSolutionTime: 'час вирішення за замовчуванням',
  delete: 'видалити',
  deleteAccount: 'видалити аккаунт',
  demo: 'демо',
  none: 'немає',
  deleteUserAccount:
    'аккаунт буде видалений, користувач більше не зможе увійти в систему.',
  description: 'опис',
  details: 'реквізити',
  disableAllSorts: 'вимкнути всі сортування',
  distance: 'відстань',
  distanceFromService: 'віддаленість від СЦ',
  document: 'документ',
  download: 'завантажити',
  edit: 'редагувати',
  editDate: 'редагувати дату',
  editingWillBeAwailableOn: 'редагування буде доступно',
  employee: 'працівник',
  eqTypes: 'типи обладнання',
  equipment: 'обладнання',
  equipments: 'обладнання',
  error: 'помилка',
  errorCreatingRepeatedOrder: 'помилка створення повторного наряд-замовлення',
  errorLoadingFromServer: 'помилка під час завантаження із сервера ',
  every: 'кожні',
  fault: 'несправность',
  faultCode: 'код несправності',
  faultGroup: 'група несправностей',
  faultGroups: 'групи несправностей',
  faults: 'несправності',
  filter: 'фільтр',
  filters: 'фільтри',
  firstDeleteAllRelations: 'спочатку потрібно видалити всі супутні елементи',
  firstName: 'ім`я',
  forgotPassword: 'забули пароль?',
  from: 'початок',
  fromClients: 'від клієнтів',
  generalInfo: 'загальна інформація',
  globals: 'глобальні',
  gps: 'gps',
  group: 'група',
  groups: 'групи',
  hide: 'сховати',
  home: 'головна',
  hours: 'годин',
  hoursDot: 'ч.',
  identFaultGroups: 'групи виявлених несправностей',
  identFaults: 'виявлені несправності',
  idents: 'виявлені',
  ingredient: 'інгредієнт',
  ingredients: 'інгредієнти',
  instruction: 'інструкція',
  isRepeat: 'повторюється',
  key: 'ключ',
  km: 'км',
  language: 'мова',
  lastName: 'прізвище',
  loading: 'завантаження',
  placement: 'розташування',
  places: 'розташування',
  location: 'локація',
  locations: 'локації',
  login: 'вхід',
  loginIncorect: 'невірний логін або пароль',
  mailingList: 'емайли для розсилки',
  managerEmail: 'email менеджера',
  managerName: 'ім`я менеджера',
  managerPhone: 'телефон менеджера',
  maximum: 'максимум',
  maxReactionTimeByContract: 'макс. час реакції за договором',
  maxSolutionTimeByContract: 'макс. час вирішення за договором',
  maxTimeOfWorkByContract: 'макс. час роботи за договором',
  maxWorkTime: 'максимальний час роботи',
  middleName: 'по батькові',
  minimum: 'мінімум',
  minutes: 'хвилин',
  minutesDot: 'хв.',
  mode: 'режим',
  model: 'модель',
  models: 'моделі',
  month: 'місяць',
  months: {
    jan: 'Січ',
    feb: 'Лют',
    mar: 'Бер',
    apr: 'Кві',
    may: 'Тра',
    jun: 'Чер',
    jul: 'Лип',
    aug: 'Сер',
    sep: 'Вер',
    oct: 'Жов',
    nov: 'Лис',
    dec: 'Гру'
  },
  name: "ім'я",
  new: 'новий',
  nextTry: 'наступна спроба',
  no: 'ні',
  noData: 'немає даних',
  noSalesForPeriod: 'за даний період продажів немає',
  notActive: 'не активний',
  notCanceled: 'не скасовані',
  notFound: 'не знайдено',
  notFoundDescription: 'можливо, ресурс було переміщено або видалено',
  notReceiveCode: 'не отримали код?',
  notRepeat: 'неповторюване',
  notification: 'повідомлення',
  notifications: 'повідомлення',
  notificationTimeTaked: 'час повідомлення до призначен',
  notificationTimeReacted: 'час повідомлення до реакції',
  notificationTimeResolved: 'час повідомлення до рішення',
  now: 'зараз',
  number: 'номер',
  object: 'об`єкт',
  objects: 'об`єкти',
  onlyActive: 'тільки активні',
  onlyByZone: 'тільки із зон',
  onlyTheir: 'тільки свої',
  opened: 'відкрито',
  order: 'наряд-замовлення',
  orderBusinessHours: 'години прийому наряд-замовлень',
  orderCancel: 'скасувати наряд-замовлення',
  orderCanceled: 'скасовано',
  orderCreatorDetails: 'подробиці наряд-замовлення',
  orderCreatorName: 'ім`я творця наряд-замовлення',
  orderCreatorPhone: 'телефон творця наряд-замовлення',
  orderCreatorType: 'тип творця наряд-замовлення',
  orderEditRules: 'правила редагування наряд-замовлення',
  orders: 'наряд-замовлення',
  totalOrders: 'всього наряд-замовлень',
  ordersInProgress: 'в роботі',
  ordersClosed: 'закрито',
  ordersByEquipment: 'наряд-замовлення по обладнанню',
  ordersCount: 'кількість наряд-замовлень',
  completedOrders: 'виконані наряд-замовлення',
  completedOrdersCount: 'кількість виконаних наряд-замовлень',
  completedOnTime: 'виконані вчасно',
  overdueOrdersCount: 'кількість прострочених наряд-замовлень',
  completed: 'виконані',
  inProgress: 'в роботі',
  orderStatus: 'статус наряд-замовлення',
  orderStatuses: 'стани наряд-замовлень',
  orderStatusHistory: 'історія статусів наряд-замовлень',
  orderTriggerHint:
    'нове наряд-замовлення буде створено, коли поточне перейде до цього статусу',
  orderType: 'типи наряд-замовлення',
  orderTypes: 'типи наряд-замовлень',
  otherFault: 'інша причина виклику',
  otherM: 'інший',
  others: 'інших',
  otherW: 'інша',
  owner: 'власник',
  owners: 'власники',
  part: 'запчастина',
  partGroup: 'група запчастин',
  partGroups: 'групи запчастин',
  parts: 'запчастини',
  password: 'пароль',
  period: 'період',
  permissions: 'дозволи',
  phone: 'телефон',
  phones: 'телефони',
  pressure: 'тиск',
  products: 'продукти',
  quantity: 'кількість',
  range: 'діапазон',
  recipe: 'рецепт',
  recipes: 'рецепти',
  noRecipe: 'рецепт не призначено',
  recipeRequired: 'для створення напою необхідно додати хоча б один інгредієнт',
  addIngredient: 'додати інгредієнт',
  manageRecipe: 'керування рецептом',
  reaction: 'реакція',
  reactionDate: 'дата початку робіт',
  reactionTime: 'час реакції',
  reactionTimer: 'таймер реакції',
  region: 'область',
  regions: 'областї',
  removeSelected: 'видалити вибране',
  repeat: 'повторювати',
  repeatedOrder: 'повторне наряд-замовлення',
  resend: 'надіслати ще раз',
  reset: 'скинути',
  resetSort: 'скинути сортування',
  retry: 'повторити',
  role: 'роль',
  roles: 'ролі',
  sales: 'продажі',
  salesByBeverages: 'продажі по напоям',
  salesByClients: 'продажі по клієнтам',
  salesByLocations: 'продажі по локаціям',
  salesByMonth: 'продажі за місяць',
  salesByPeriod: 'продажі за період',
  salesByWeek: 'продажі за тиждень',
  salesByYear: 'продажі за рік',
  save: 'зберегти',
  savePassword: 'зберегти пароль',
  salesByWeekDays: 'продажі по днях тижня',
  salesByHours: 'продажі по годинах',
  search: 'пошук',
  selectAll: 'вибрати все',
  selectDaysOfTheWeek: 'виберіть дні тижня',
  sendCode: 'надіслати код',
  serialNumber: 'серійний номер',
  serverError: 'помилка сервера',
  serverValidationError: 'помилка перевірки на сервері',
  serviceCenter: 'сервісний центр',
  settings: 'налаштування',
  scanQrForServiceRequest:
    'Відскануйте цей QR для створення наряд-замовлення на ремонт',
  shortName: 'ім`я',
  show: 'показати',
  showAllColumns: 'показати всі колонки',
  showLessColumns: 'приховати колонки',
  showMore: 'показати ще',
  showTelemetry: 'показати телеметрію',
  sla: 'угода про рівень обслуговування',
  solution: 'рішення',
  solutionDate: 'дата закінчення робіт',
  solutionTime: 'час вирішення',
  solutionTimer: 'таймер рішення',
  sort: 'сортування',
  startTravelTimer: 'запустити таймер в дорозі',
  sortDefault: 'сортування за замовчуванням',
  staff: 'співробітник',
  staffs: 'співробітники',
  state: 'стан',
  status: 'стан',
  statuses: 'стани',
  suspended: 'призупинено',
  stopNotifications: 'зупинити повідомлення',
  stopReactionTimer: 'зупинити таймер реакції',
  stopSolutionTimer: 'зупинити таймер рішення',
  stopTravelTimer: 'зупинити таймер в дорозі',
  superAdmin: 'супер-адмін',
  tableWidth: 'ширина таблиці',
  telegram: 'телеграм',
  telemetry: 'телеметрія',
  time: 'час',
  timeByFaultType: 'час за типом несправності',
  timeDefault: 'час за замовчуванням',
  timeOfWork: 'час роботи',
  title: 'назва',
  to: 'закінчення',
  toRecoverPassword:
    'Щоб відновити свій пароль, введіть свій номер телефону, і ми надішлемо вам SMS із кодом відновлення',
  total: 'всього',
  totalClients: 'всього клієнтів',
  totalLocations: 'всього локацій',
  totalSales: 'загальні продажі',
  transitionFrom: 'перехід з',
  transitionTo: 'перехід на',
  travelTime: 'час у дорозі',
  trigger: 'тригер',
  type: 'тип',
  types: 'типи',
  unit: 'одиниця виміру',
  units: 'одиниці виміру',
  unselectAll: 'скасувати вибір усіх',
  update: 'редагувати',
  user: 'користувач',
  userName: 'ім`я користувача',
  users: 'користувачі',
  verifyCode: 'перевірити код',
  video: 'відео',
  voltage: 'напруга',
  waitLoadingFromServer:
    'очікування завантаження з сервера',
  warning: 'попередження',
  week: 'тиждень',
  weeks: 'тижні',
  withoutAccount: 'без акаунту',
  work: 'работа',
  workType: 'тип роботи',
  workTypes: 'типи робіт',
  workGroups: 'групи робіт',
  works: 'работи',
  year: 'рік',
  yes: 'так',
  zone: 'зона',
  zoneBy: 'зона по',
  byClients: 'контрагентам',
  byModels: 'моделях',
  byCities: 'містах',
  zones: 'зони',
  zonesFilterMode: 'режим фільтрації зон:',
  validation: {
    alpha: 'має містити тільки літери',
    alreadyTaked: 'вже зайнято',
    alreadyStaff: 'інший виконавець вже є в списку, перезавантажте сторінку',
    brand: {
      notActive: 'бренд не активний'
    },
    client: {
      notActive: 'клієнт не активний'
    },
    contract: {
      notActive: 'не знайдено активний договір',
      notActiveOrExpired:
        'не знайдено активний договір або термін дії договору закінчився'
    },
    email: 'повинна бути дійсна електронна адреса',
    emails: 'вводити електронні листи через кому',
    eqType: {
      notActive: 'тип обладнання не активний'
    },
    equipment: {
      notActive: 'обладнання не активне'
    },
    integer: 'повинно бути цілим числом',
    ipVsPort: 'має бути дійсним ip та портом: xxx.xxx.xxx.xxx:xxxxx',
    isChangedValue: 'виберіть нове значення',
    length: 'має мати {n} символ | має містити {n} символів',
    location: {
      notActive: 'локація не активна'
    },
    maxLength: 'макс. {n} символ | макс. {n} символів',
    maxValue: 'максимальне значення - {n}',
    minLength: 'мін. {n} символ | мін. {n} символів',
    minValue: 'мінімальне значення - {n}',
    model: {
      notActive: 'model is not active',
      noContract:
        'не знайдено активного договору для цієї моделі обладнання або строк договору минув'
    },
    numeric: 'має бути число',
    password: {
      hasLowerCase: 'малу літеру',
      hasNumbers: 'цифру',
      hasSymbol: 'символ',
      hasUpperCase: 'велику літеру',
      minLength: 'мін. 8 символів',
      mustContain: 'пароль повинен містити:'
    },
    passwordMismatch: 'паролі не співпадають',
    phone: 'має бути дійсний номер телефону: +XXXXXXXXXXX',
    repeatedOrderDate:
      'увага! Дата наступного наряд-замовлення перевищує термін дії договору на обслуговування обладнання, замовлення може бути не створено!',
    required: 'не може бути порожнім',
    requiredOneOf: 'заповніть хоча б одне з полів',
    sameAs: 'не збігається з: {n}',
    url: 'має бути дійсним URL-посиланням',
    ingredientsInUse: 'Інгредієнт {ingredients} використовується в існуючому обладнанні. Ви хочете видалити інгредієнт з усього обладнання ({count} шт)? | Інгредієнти {ingredients} використовуються в існуючому обладнанні. Ви хочете видалити інгредієнти з усього обладнання ({count} шт)?',
    confirmRemoval: 'Підтвердити видалення',
    cancelRemoval: 'Скасувати'
  },
  weekDays: {
    sunday: 'неділя',
    monday: 'понеділок',
    tuesday: 'вівторок',
    wednesday: 'середа',
    thursday: 'четвер',
    friday: "п'ятниця",
    saturday: 'субота',
    holiday: 'вихідний',
    sun: 'нд',
    mon: 'пн',
    tue: 'вт',
    wed: 'ср',
    thu: 'чт',
    fri: 'пт',
    sat: 'сб'
  },
  $vuetify: uk
}
